<template>
    <div>
        <el-dialog title="拼多多打标相关问题" :visible.sync="dialog" center width="800px" :close-on-click-modal="false" top="50px">
            <div class="bind-phone-dialog">
                <div class="text-fmt">
                    <div><span style="font-family: Arial; color: rgb(223, 64, 42)">打标须知</span></div>

                    <div><span style="font-family: Arial; color: rgb(223, 64, 42)">打标使用后的效果</span></div>

                    <div><font color="#393939">1.只需输入要打标的宝贝ID，以及目标用户的UID。</font></div>

                    <div>
                        <span style="font-family: Arial; color: rgb(57, 57, 57)"
                            >2.提交打标请求之后，买家搜索商品相关的关键词、能将打标的商品排名提高到搜索页面前20名，即为打标成功。</span
                        >
                    </div>

                    <div>
                        <span style="font-family: Arial; color: rgb(57, 57, 57)">3.只需几秒，打标的商品就会出现在指定账号的拼多多搜索首屏比较靠前的位置。</span>
                    </div>

                    <div><span style="font-family: Arial; color: rgb(57, 57, 57)">4.期间不需要买家多多号介入任何流程。</span></div>

                    <div><span style="font-family: Arial; color: rgb(223, 64, 42)">打标的使用场景</span></div>

                    <div><span style="font-family: Arial; color: rgb(57, 57, 57)">1.商品核心词权重低搜索不到，但是想通过核心词搜索下单成交。&nbsp;</span></div>

                    <div>
                        <span style="font-family: Arial; color: rgb(57, 57, 57)"
                            >2.对于潜在用户，比如咨询未付款的客户，可对他们进行打标，让商品出现在搜索结果页的前排。</span
                        >
                    </div>

                    <div>
                        <span style="font-family: Arial; color: rgb(57, 57, 57)"
                            >3.对于复购率很高的宝贝，列出老客户或者精准客户UID清单，然后批量打标，快速引爆流量。</span
                        >
                    </div>

                    <div>
                        <span style="font-family: Arial; color: rgb(57, 57, 57)"
                            >4.提前对大量多多号打标，并配合做单，可提高商品入池的机会，结合拼多多的千人千面机制，获得更多拼多多搜索流量。</span
                        >
                    </div>

                    <div><span style="font-family: Arial; color: rgb(223, 64, 42)">打标常见问题</span></div>

                    <div>
                        <span style="font-family: Arial; color: rgb(57, 57, 57)"
                            >1.宝贝要求有一定的基础销量，一般10个以上，如果销量过低，即使打标成功，也有可能没有打标效果。&nbsp;</span
                        >
                    </div>

                    <div>
                        <span style="font-family: Arial; color: rgb(57, 57, 57)"
                            >2.如果通过打标词在前10位商品未找到，可以在前20位商品寻找；如果仍然未找到请打开拼多多的历史浏览，确定是否出现打标商品，如果未出现请联系客服。&nbsp;</span
                        >
                    </div>

                    <div>
                        <span style="font-family: Arial; color: rgb(57, 57, 57)"
                            >3.有时被打标的宝贝位置可能在20页开外，可以往下多翻几页。这种情况大概率是因为该商品权重值太低。</span
                        >
                    </div>

                    <div>
                        <span style="font-family: Arial; color: rgb(57, 57, 57)"
                            >4.并非所有类目的宝贝可成功进行打标，综合体验异常、因违规被扣分的商品，可能无法成功打标，即使打标成功效果也很小，不明显。&nbsp;</span
                        >
                    </div>

                    <div>
                        <span style="font-family: Arial; color: rgb(57, 57, 57)"
                            >5.打标成功的有效时长根据拼多多更新时间，打标前可以用自己的号测试看下效果，再进行批量打标。&nbsp;</span
                        >
                    </div>

                    <div>
                        <span style="font-family: Arial; color: rgb(57, 57, 57)"
                            >6.同一个多多号当日被打标次数超过一定的限度，会降低打标后的效果，建议多多号不宜在一天超过10次打标。</span
                        >
                    </div>

                    <div><br /></div>

                    <div><br /></div>

                    <div><span style="font-family: Arial; color: rgb(223, 64, 42)">打标攻略1</span></div>

                    <div><span style="font-family: Arial; color: rgb(223, 64, 42)">商家的问题：</span></div>

                    <div><span style="font-family: Arial; color: rgb(57, 57, 57)">拼多多用户UID是什么？</span></div>

                    <div><span style="font-family: Arial; color: rgb(223, 64, 42)">解决方案：</span></div>

                    <div>
                        <span style="font-family: Arial; color: rgb(57, 57, 57)"
                            >每个淘宝号都有一个旺旺号，不可更改，是买家在淘宝的唯一标识。拼多多也是如此，每个账号都有一个用户UID，不可更改，是买家在拼多多上的唯一标识。</span
                        >
                    </div>

                    <div><br /></div>

                    <div><span style="color: rgb(223, 64, 42); font-family: Arial">打标攻略2</span><br /></div>

                    <div><span style="font-family: Arial; color: rgb(223, 64, 42)">商家的问题：</span></div>

                    <div><span style="font-family: Arial; color: rgb(57, 57, 57)">拼多多用户UID怎么获取？</span></div>

                    <div><span style="font-family: Arial; color: rgb(223, 64, 42)">解决方案：</span></div>

                    <div>打开拼多多APP随意搜索一个产品，然后随意点一个产品链接分享，然后发送qq或者微信聊天页面，就能看到UID。</div>

                    <div>
                        <a data-fancybox="gallery" href="https://pic.rmb.bdstatic.com/bjh/26ac3ecb804b6c4689b480df8e348b44.png"
                            ><img
                                src="https://pic.rmb.bdstatic.com/bjh/26ac3ecb804b6c4689b480df8e348b44.png"
                                class="img-responsive"
                                style="width: 439.5px; height: 657.702px"
                                alt="attachments-2020-10-omYPEDYM5f81583184a58.png" /></a
                        ><br /><br /><br />
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            dialog: !!this.value,
        }
    },
    methods: {},
    mounted() {},
    watch: {
        dialog(val) {
            if (!val) this.$emit('input', val)
        },
    },
}
</script>
<style lang="scss">
</style>
